import React, { Component } from 'react';
import PropTypes from "prop-types";
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';

import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

@catchLifeCycleErrors
export default class HorseRacingFastCardsPage extends Component {
  static propTypes = {
    HorseRacingFastCards: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      HorseRacingFastCards,
    } = this.props;

    return (
      <div className="fast-cards-page">
        <StandardPage sport="racing" title="Fast cards">
          <div className="main-layout-left-column">
            {HorseRacingFastCards}
          </div>

          <RightColumn location={location}
                       sport="racing"
                       content={
                         ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu",  "ocWidget"]} />
        </StandardPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingFastCardsPage.js